import { IPurchaseContractPagedRequest } from '../../../../model/apm/purchase-contract/request/purchase-contract-paged-request';
import { IPurchaseContractResponse } from '../../../../model/apm/purchase-contract/response/purchase-contract-response';
import { ILookupResponse } from '../../../../model/apm/base/lookup-response';
import { IPortalDocumentResponse } from '../../../../model/apm/document/portal-document-response';

export type PurchaseContractSearchState = {
    parameters: IPurchaseContractPagedRequest;
    searchTrigger: number;
    documentTypes: ILookupResponse[];
    // Anexos ficam separados do registro para não reiniciar o formulário a cada envio
    drawer: { open: boolean; contract?: IPurchaseContractResponse; files: IPortalDocumentResponse[] };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    setDocumentTypes = 'setDocumentTypes',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
    setDrawerFiles = 'setDrawerFiles',
}

export const PurchaseContractSearchReducer = (state: PurchaseContractSearchState, action: any): PurchaseContractSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.setDocumentTypes:
            return { ...state, documentTypes: payload };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, contract: payload, files: payload?.files || [] } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false, files: [] } };
        case ACTION_TYPES.setDrawerFiles:
            return { ...state, drawer: { ...state.drawer, files: payload } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
